import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {CloudFileModel} from '../../api/models';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {NotificationService} from '../../notification/notification.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {HolidayGreetingsTextToSpeechDialogComponent} from './holiday-greetings-text-to-speech-dialog.component';
import {Dictionary} from 'lodash';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel } from '@angular/material/form-field';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { NgFor, NgIf } from '@angular/common';
import { UploadHolidayGreetingsComponent } from '../upload-holiday-greetings/upload-holiday-greetings.component';

export interface HolidayGreetingsEditRecordingDialogData {
  availableHolidayGreetings: CloudFileModel[];
  availableHolidayGreetingsGrouped: Dictionary<CloudFileModel[]>;
  recId: string;
}

@Component({
    selector: 'app-pbx-holiday-greetings-edit-recording-dialog',
    template: `
    <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
      <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
        <div fxFlex>Select Holiday Greetings Recording</div>
        <button mat-icon-button [mat-dialog-close]="false" class="button-40">
          <mat-icon>close</mat-icon>
        </button>
      </h1>
      <mat-dialog-content style="display: flex; align-items: stretch;">
        <div fxFlex class="stretched-container" style="padding: 5px">
          <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
            <mat-label class="label-text" style="margin-bottom: 20px; display: block">Holidays greeting audio files</mat-label>
            <mat-accordion [multi]="true">
              <mat-radio-group aria-label="Select an option" fxLayout="column" fxLayoutGap="10px" [formControl]="fileOptionControl">
                <div *ngFor="let group of groupKeys">
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title >
                        {{ group }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-radio-button value="{{rec.id}}" *ngFor="let rec of data.availableHolidayGreetingsGrouped[group]">
                      <div fxLayout="column" fxLayoutGap="10px">
                        <span *ngIf="rec.id != '-2' && rec.id != '-1' && rec.name != 'Current Holiday Greeting'" class="label-text">{{ rec.name }}</span>

                        <audio *ngIf="rec.id != '-1' && rec.id != '-2'" controls
                               src="{{'/api/holiday-greetings/pre-audio/stream/' + rec.id}}"></audio>

                        <app-upload-holiday-greetings #fileInput name="upload-audio1" id="upload-audio1"
                                                      *ngIf="rec.id == '-1'"
                                                      (validationError)="onFileValidationError($event)"
                                                      (valueChanged)="onFileChanged($event)"
                        ></app-upload-holiday-greetings>

                        <div *ngIf="rec.id == '-2'">
                          <button type="button" mat-raised-button color="primary" (click)="onTextToSpeech()">Generate audio by Text
                          </button>
                        </div>

                      </div>
                    </mat-radio-button>
                  </mat-expansion-panel>
                </div>
              </mat-radio-group>
            </mat-accordion>
          </form>
        </div>
      </mat-dialog-content>

      <div mat-dialog-actions style="justify-content: flex-end;">
        <button type="button" mat-stroked-button color="primary" (click)="onSubmit()">Save</button>
        <button type="button" mat-stroked-button [mat-dialog-close]="false">Close</button>
      </div>
    </div>
  `,
    styles: [
        '.stretched-container {overflow: auto;}'
    ],
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatLabel, MatAccordion, MatRadioGroup, NgFor, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatRadioButton, NgIf, UploadHolidayGreetingsComponent, MatButton, MatDialogActions]
})
export class HolidayGreetingsEditRecordingDialogComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup;
  file1: File;
  fileOptionControl = new UntypedFormControl('0', []);

  groupKeys: string[] = [];

  constructor(public dialogRef: MatDialogRef<HolidayGreetingsEditRecordingDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: HolidayGreetingsEditRecordingDialogData,
              public dialog: MatDialog,
              private notificationService: NotificationService,
              private fb: UntypedFormBuilder,
  ) {

  }

  async onSubmit() {
    if (this.form.valid) {
      const reqData = this.prepareFormModel();
      if (reqData.recId === '-1' && !this.file1) {
        this.notificationService.notifyDanger('Custom holiday greeting file is not selected');
        return;
      }
      this.dialogRef.close(reqData);
    } else if (!this.form.valid) {
      console.error('form not valid', this.form.errors);
    }
  }

  prepareFormModel(): any {
    const formModel = this.form.getRawValue();

    const fileData = this.data.availableHolidayGreetings.find(x => x.id === formModel.fileOption);

    console.log(fileData);

    return {
      file: (formModel.fileOption == '-1' || formModel.fileOption == '-2') ? this.file1 : null,
      recId: formModel.fileOption,
      filename: this.file1 ? this.file1.name : fileData ? fileData.name :  '',
    };
  }

  onFileValidationError($event: string) {
    this.notificationService.notifyDanger($event);
  }

  onFileChanged($event: File) {
    console.log('On file 1 changed', $event);
    this.file1 = $event;
    this.form.patchValue({
      fileOption: '-1'
    });
  }

  ngOnInit() {

    this.groupKeys = Object.keys(this.data.availableHolidayGreetingsGrouped);

    this.fileOptionControl = new UntypedFormControl(this.data.recId, [Validators.required]);
    this.form = this.fb.group({
        'fileOption': this.fileOptionControl,
      },
    );
  }

  ngOnDestroy() {

  }

  onTextToSpeech() {
    this.form.patchValue({
      fileOption: '-2'
    });

    const dialogRef = this.dialog.open(HolidayGreetingsTextToSpeechDialogComponent, {
      id: 'holiday-greetings-text-to-speech-dialog',
      width: '600px',
      height: '70%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        console.log(result);

        const audioBlob = this.convertBase64ToBlob(result.base64, result.mimeType);
        this.file1 = new File([audioBlob], 'text-to-speech.wav', {type: result.mimeType});

        this.form.patchValue({
          fileOption: '-2'
        });

        this.onSubmit().then();
      }
    });
  }

  convertBase64ToBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {type: mimeType});
  }
}
